module.exports = __webpack_public_path__ + "img/periodic_mbcn.dc2a0597.png";